@if (decision_table?.framework.analysis_type) {
  @if (getAnalysisService().isMultiobjectiveByType(decision_table?.framework.analysis_type)) {
    <app-multiobjective-responses-weight-criteria [evaluationSessionId]="id" [allDecisionInfo]="allInfo" (responseWeightCriteriaSavedEvent)="weightCriteriaSaved()"></app-multiobjective-responses-weight-criteria>
  }
}

@if (decision_table?.framework.analysis_type) {
  @if (getAnalysisService().isMulticriteriaByType(decision_table?.framework.analysis_type)) {
    <app-multicriteria-responses-weight-criteria [evaluationSessionId]="id" [allDecisionInfo]="allInfo" (responseWeightTargetSavedEvent)="weightTargetSaved()"></app-multicriteria-responses-weight-criteria>
  }
}

<!-- Non ci sono pesi dei criteri per la consensus -->
